import React, { useState, useEffect } from "react";
import {
  Box, Typography, List, ListItem, ListItemText, Button
} from "@mui/material";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Header from "../../components/Header";

const formatDangerScore = (client) => {
  if (client.dangerScore == null) return "-";
  return `${Math.round(client.dangerScore * 100)}%`;
};

export default function SuggestedClients() {
  const [allClients, setAllClients] = useState([]);
  const [selectedClients, setSelectedClients] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchClients();
  }, []);

const fetchClients = async () => {
  const token = sessionStorage.getItem("token");
  try {
    const res = await axios.get("/api/map/suggested-clients", {
      headers: { Authorization: `Bearer ${token}` }
    });
    const clients = res.data?.targets || [];
    setAllClients(clients);
    setSelectedClients(clients); // ← 追加：最初から全選択
  } catch (err) {

  }
};

  const toggleClientSelection = (client) => {
    setSelectedClients(prev =>
      prev.some(c => c.id === client.id)
        ? prev.filter(c => c.id !== client.id)
        : [...prev, client]
    );
  };

  const handleGoToRoute = () => {
    sessionStorage.setItem("selectedClients", JSON.stringify(selectedClients));
    navigate("/map/route");
  };

  return (
    <>
      <Header />
      <Box p={2}>
        <Typography variant="h6">補充提案一覧</Typography>
        <List>
          {[...allClients]
            .sort((a, b) => (b.dangerScore ?? 0) - (a.dangerScore ?? 0))
            .map(client => (
              <ListItem
                key={client.id}
                button
                onClick={() => toggleClientSelection(client)}
                selected={selectedClients.some(c => c.id === client.id)}
                sx={{ py: 0.5 }}
              >
                <ListItemText
                  primary={
                    <Box display="flex" alignItems="center">
                      <Typography variant="body2" fontWeight="bold">{client.name}</Typography>
                      {(!client.address || client.address.trim() === "") && (
                        <Typography variant="caption" color="error" sx={{ ml: 1 }}>
                          ※住所未登録
                        </Typography>
                      )}
                    </Box>
                  }
                  secondary={
                    <Typography variant="caption" color="text.secondary">
                      予測: {client.predictedQuantity ?? "-"}L / 閾値: {client.thresholdQuantity ?? "-"}L
                    </Typography>
                  }
                />
              </ListItem>
            ))}
        </List>

        <Button
          fullWidth
          variant="contained"
          onClick={handleGoToRoute}
          sx={{ mt: 2 }}
          disabled={selectedClients.length === 0}
        >
          ルートを確認する
        </Button>
      </Box>
    </>
  );
}
